import React, { useState } from "react";
import PropTypes from "prop-types";

const BlogPostCard = ({ post }) => {
    const [ state, setState ] = useState({
        imgSrc: post.imgSrc,
        imgError: false
    });

    const onImageError = () => {
        if(!state.imgError){

            setState({
                imgSrc: "/images/image-not-found.png",
                imgError: true
            });
        }
    };

    return (
        <div className="blog-post-card">
            <div>
                <a
                    href={post.href}
                    role="link"
                    aria-label={`Read More - ${post.title}`}
                >
                    <img
                        src={state.imgSrc}
                        onError={onImageError}
                        className="img-fluid"
                        alt={`Article Image For ${post.title}`}
                        style={{ objectFit: state.imgError ? "contain" : "cover" }}
                    />
                </a>
            </div>
            <div className="blog-post-card-body">
                <h2>
                    <a
                        href={post.href}
                        className="card-title"
                        role="link"
                        aria-label={`Read More - ${post.title}`}
                    >
                        {post.title}
                    </a>
                </h2>
                <p className="mb-0">{post.creation_time}</p>
                <p className="description">{post.short_content}</p>
                <div className="read-more">
                    <a
                        href={post.href}
                        className="btn btn-outline-lx"
                        role="link"
                        aria-label={`Read More - ${post.title}`}
                    >
                        <i className="fa fa-book"/>
                        Read More
                    </a>
                </div>
            </div>
        </div>
    );
};

BlogPostCard.propTypes = {
    post: PropTypes.object.isRequired
};

export default BlogPostCard;